import React from 'react';
import FormField from '../FormField';

export default function InfraestruturaLogistica() {
  return (
    <div>
    <div className="mb-6 p-4 bg-blue-50 rounded-lg">
      <p className="text-sm text-blue-700">Esta seção coleta informações sobre a infraestrutura e logística disponível no município.</p>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <FormField
        name="abastecimento_agua"
        label="Abastecimento de água (%)"
        type="percent"
        placeholder="Digite a porcentagem"
        helpText="Porcentagem da população atendida com água"
        defaultValue={({ field, formState }) => {
          // Backward compatibility for old 'saneamento_basico' field
          if (formState.defaultValues?.saneamento_basico && !field.value) {
            return formState.defaultValues.saneamento_basico / 2;
          }
          return field.value;
        }}
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
      
      <FormField
        name="coleta_esgoto"
        label="Coleta de esgoto (%)"
        type="percent"
        placeholder="Digite a porcentagem"
        helpText="Porcentagem da população atendida com coleta de esgoto"
        defaultValue={({ field, formState }) => {
          // Backward compatibility for old 'saneamento_basico' field
          if (formState.defaultValues?.saneamento_basico && !field.value) {
            return formState.defaultValues.saneamento_basico / 2;
          }
          return field.value;
        }}
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
      
      <FormField
        name="energia_eletrica"
        label="Energia elétrica (%)"
        type="percent"
        placeholder="Digite a porcentagem"
        helpText="Porcentagem da população atendida"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
      
      <FormField
        name="acesso_internet"
        label="Acesso à internet (%)"
        type="percent"
        placeholder="Digite a porcentagem"
        helpText="Porcentagem da população com acesso"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
          max: {
            value: 100,
            message: 'O valor deve ser menor ou igual a 100',
          },
        }}
      />
    </div>
    
    <div className="mt-4">
      <FormField
        name="qualidade_rodovias"
        label="Qualidade da infraestrutura rodoviária"
        type="select"
        options={[
          { value: '1', label: '1 - Péssima' },
          { value: '2', label: '2 - Ruim' },
          { value: '3', label: '3 - Regular' },
          { value: '4', label: '4 - Boa' },
          { value: '5', label: '5 - Ótima' },
        ]}
        helpText="Avalie a qualidade das estradas de 1 (péssima) a 5 (ótima)"
      />
    </div>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      <FormField
        name="proximidade_centros_logisticos"
        label="Proximidade de centros logísticos"
        placeholder="Descreva a proximidade de centros logísticos"
        helpText="Ex: distância até portos secos, centros de distribuição, etc."
      />
      
      <FormField
        name="distancia_aeroporto"
        label="Distância ao aeroporto mais próximo (km)"
        type="numeric"
        placeholder="Digite a distância em km"
        helpText="Distância em quilômetros até o aeroporto mais próximo"
        suffix=" km"
        validation={{
          min: {
            value: 0,
            message: 'O valor deve ser maior ou igual a 0',
          },
        }}
      />
    </div>
    <hr className="border-t border-gray-300 my-6" />
    <div className="mt-6 space-y-4">
      <FormField
        name="fontes_principais_secao4"
        label="Fontes principais"
        type="textarea"
        placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
        helpText=""
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
      
      <FormField
        name="links_acesso_secao4"
        label="Links de acesso"
        type="textarea"
        placeholder="Insira os links para acesso às fontes"
        helpText="Informe URLs para acesso às fontes quando disponível"
        rows={3}
        className="[&_.input]:min-h-[5rem]"
      />
    </div>
  </div>
  );
}
